import moment, { type Moment } from 'moment';
import { QuestionType } from './base';
import { TextMessage } from './i18n';
import { QuestionObject } from './question_object';

export type CommentTypes = 'question' | 'note';
export type CommentValues = {
  user?: string;
  createTime?: Moment;
  commentType?: CommentTypes;
};

export class CommentQuestion extends QuestionObject<string> {
  commentValues: CommentValues;

  constructor(id: string, title: TextMessage, commentValues?: CommentValues) {
    super(id, QuestionType.Comment, title);
    this.commentValues = {};
    if (commentValues) {
      if (commentValues.user) {
        this.commentValues.user = commentValues.user;
      }
      if (commentValues.createTime) {
        this.commentValues.createTime = commentValues.createTime;
      }
      if (commentValues.commentType) {
        this.commentValues.commentType = commentValues.commentType;
      }
    }
  }

  public updateCreateTime() {
    this.commentValues.createTime = moment();
  }

  public updateUser(user: string) {
    this.commentValues.user = user;
  }

  public updateCommentType(commentType: CommentTypes) {
    this.commentValues.commentType = commentType;
  }

  public read(o: any): this {
    super.read(o);
    if (o.user) this.commentValues.user = o.user;
    if (o.createTime) this.commentValues.createTime = moment(o.createTime);
    if (o.commentType) this.commentValues.commentType = o.commentType;
    return this;
  }

  public save(): any {
    let result = super.save();
    result = {
      ...result,
      user: this.commentValues.user,
      commentType: this.commentValues.commentType,
    };
    if (this.commentValues.createTime) {
      result.createTime = this.commentValues.createTime.toISOString();
    }
    return result;
  }
}
